<app-adloop-card [class]="'display-block full-height ' + backgroundImgClass">
  <app-form-builder
    [form]="form"
    [formDef]="formDef"
    [loader]="loader"
    [errors]="errors"
    (onSubmit)="submit($event)"></app-form-builder>
</app-adloop-card>
